import { render, staticRenderFns } from "./edit-limit-modal.vue?vue&type=template&id=1c285bdf&scoped=true"
import script from "./edit-limit-modal.vue?vue&type=script&lang=js"
export * from "./edit-limit-modal.vue?vue&type=script&lang=js"
import style0 from "./edit-limit-modal.vue?vue&type=style&index=0&id=1c285bdf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c285bdf",
  null
  
)

export default component.exports